/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/

var FX_PIXFLD = 0;
var FX_IKAT = 1;
var FX_STRIPE = 2;
var FX_GLACIER = 3;
var FX_CRIMP = 4;
var FX_THATCH = 5;
var FX_CAIRO = 6;
var FX_SCATTER = 7;
var FX_ZAG = 8;
var FX_SEQUENCE = 9;
var FX_ICE = 10;
var FX_CAPE = 11;

var FX_NUM = 12;
var fx_thumb_img = new Array(FX_NUM);
var fx_thumbs_ready = 0;
var fx_thumbs_refresh = 0;
var THUMB_SIZE = 150;

var THUMBS_LEFT = 20;
var THUMBS_TOP = 30;
var THUMBS_SPAN = 190;
var FX_BAR_WIDTH = 10;
var FX_BAR_RIGHT = 7;
var FX_BAR_VERT_GAP = 40;
var FX_BAR_HEIGHT = 30;

var fx_name = [ "Pixel Field", "Ikat", "Stripes", "Glacier", "Crimp", "Thatch", "Cairo", "Scatter", "Zag", "Sequence", "Ice", "Cape" ];

var fx_selected = 0;

var fxlist = { drag: 0, width: 0, height: 0, disp_height: 0, scroll_height: 0, scroll_pos: 0, scrollbar_pos: 0, drag_dif: 0, scrollbar: 0 };

var fxlist_col_sel = new RGB(0xE3, 0x18, 0x37);
var FXLIST_FONT = "13px Arial";

// just for preview params
var filter1_pixel_size = 0.25;
var filter1_shift_x = 49;
var filter1_shift_y = 49;
var filter1_pixel_disp = 0;
var filter1_pixel_rand1 = 0, filter1_pixel_rand2 = 0;

var filter2_step = 0.3;
var filter2_width = 0.1;
var filter2_rand_dist1 = 46.5;
var filter2_rand_dist2 = 46.5;

function fxlist_select(f)
{
	fx_selected = f;
	set_filter(f);
	fxlist_paint();
}

function fxlist_generate_thumb_finish(pos, api, callback)
{
	if (api)
	{
		if (callback != null) callback(0, fx_thumb_img[pos]);
		return;
	}

	pos++;
	if (pos == FX_NUM)
	{
		fx_thumbs_ready = 1;
		fx_thumbs_refresh = 1;
	}
	else
	fxlist_generate_thumb_phase1(pos, 0, null);
}

function fxlist_generate_thumb_compose(pos, api, callback)
{
	context_bitmap.setTransform(1, 0, 0, 1, 0, 0);
	context_bitmap.clearRect(0, 0, THUMB_SIZE, THUMB_SIZE);

	context_bitmap.globalAlpha = 1;
	context_bitmap.drawImage(layer1_img, 0, 0);
	context_bitmap.globalAlpha = 0.6;
	context_bitmap.drawImage(layer2_img, 0, 0);

	fx_thumb_img[pos] = new Image();
	fx_thumb_img[pos].src = canvas_bitmap.toDataURL("image/raw");
	if (typeof pf_nodejs === "undefined")
		fx_thumb_img[pos].onload = function func() { fxlist_generate_thumb_finish(pos, api, callback); };
	else
		fxlist_generate_thumb_finish(pos, api, callback);
}

function fxlist_generate_thumb_phase2(pos, api, callback)
{
	context_bitmap.clearRect(0, 0, THUMB_SIZE, THUMB_SIZE);

	var vl2;	var filter2_step = UI.valuef_def("ikat_width") *100/8;
	var filter5_step = UI.valuef("crimp_size") * 100/0.8;
	var filter6_step = UI.valuef("thatch_width")*100/8;
//alert(pos + " api " + api);
	switch (pos)
	{
		case FX_PIXFLD:
			vl2 = vectorize_filter1(0,60,60,   1,0,null, UI.valuef_def("pf_width"), UI.value_def("pf_shape"), 0/*UI.valuef_def("pf_displace")*/, UI.value_def("pf_rnd2"), 0, PIXFLD_LAYER2_OFFSET, PIXFLD_LAYER2_OFFSET);
			break;
		case FX_IKAT:
			vl2 = vectorize_filter2(0,60,60,   1,0,null,  0, filter2_step, filter2_width, 100, 25, 0, filter2_rand_dist2);
			break;
		case FX_STRIPE:
			vl2 = vectorize_stripes(0,60,60,     1,0,null, UI.valuef_def("stripe_width")*0.3, UI.valuef_def("stripe_width"), UI.value_def("stripe_variation"), 75, UI.value_def("stripe_rotation"), UI.value_def("stripe_rnd2"));
			break;
		case FX_GLACIER:
			vl2 = vectorize_glacier(0,60,60,     1,0,null, UI.valuef_def("glacier_width"), 100, 0, UI.value_def("glacier_rnd2"));
			break;
		case FX_CRIMP:
			vl2 = vectorize_crimp(0,60,60,       1,0,null, filter5_step, UI.valuef_def("crimp_size"), UI.valuef_def("crimp_wave"), 95, 0, UI.value_def("crimp_rnd2"));
			break;
		case FX_THATCH:
			vl2 = vectorize_thatch(0,60,60,      1,0,null, 0, filter6_step, UI.valuef_def("thatch_width"), UI.value("thatch_shape"), UI.value_def("thatch_spacing"), 60, 0, UI.value_def("thatch_rnd2"));
			break;
		case FX_CAIRO:
			vl2 = vectorize_cairo(0,60,60,       1,0,null, UI.valuef_def("cairo_size")*4, UI.valuef_def("cairo_angle"), UI.value_def("cairo_rnd2"), UI.valuef_def("cairo_rotation"));
			break;
		case FX_SCATTER:
			vl2 = vectorize_scatter(0,60,60,     1,0,null, 1, 80, 0, 20, 0 );
			break;
		case FX_ZAG:
			vl2 = vectorize_zag(0,60,60,    1,0,null, 1, 1.5, 1.5, UI.valuef_def("zag_variation"), 0, UI.value_def("zag_rand2"));
			break;
		case FX_SEQUENCE:
			vl2 = vectorize_sequence(0,60,60,   1,0,null, UI.valuef_def("sequence_width"), UI.valuef_def("sequence_height"), UI.value_def("sequence_variation"), UI.value_def("sequence_break"), UI.value_def("sequence_shuffle"), 0, 0);
			break;
		case FX_ICE:
			vl2 = vectorize_ice(0,60,60,   1,0,null, 2.5 /*UI.valuef_def("ice_scale")*/, UI.value_def("ice_shape"), UI.value_def("ice_spacing"), UI.value_def("ice_shuffle"), UI.value_def("ice_angle"), UI.value_def("pf_rnd2"), 0, PIXFLD_LAYER2_OFFSET, PIXFLD_LAYER2_OFFSET);
			break;
		case FX_CAPE:
			vl2 = vectorize_cape(0,60,60,   1,0,null, 10/*UI.valuef_def("cape_scale")*/, UI.value_def("cape_stripe"), UI.valuef_def("cape_shape"), UI.value_def("cape_rnd2"), 0, CAPE_LAYER2_OFFSET, CAPE_LAYER2_OFFSET);
			break;
	}

	paint_vectors(context_bitmap, vl2, THUMB_SIZE, 60, 60, 1/*0.5*/, 2, -1, -1, 0, 5);

	layer2_img = new Image();
	layer2_img.src = canvas_bitmap.toDataURL("image/raw");
	if (typeof pf_nodejs === "undefined")
		layer2_img.onload = function func() { fxlist_generate_thumb_compose(pos, api, callback); };
	else
		fxlist_generate_thumb_compose(pos, api, callback);
}

function fxlist_generate_thumb_phase1(pos, api, callback)
{
	context_bitmap.clearRect(0, 0, THUMB_SIZE, THUMB_SIZE);

	var vl1;
	var filter2_step = UI.valuef_def("ikat_width") *100/8;
	var filter5_step = UI.valuef("crimp_size") * 100/0.8;
	var filter6_step = UI.valuef("thatch_width")*100/8;

	switch (pos)
	{
		case FX_PIXFLD:
			vl1 = vectorize_filter1(0,60,60,   0,0,null, UI.valuef_def("pf_width"), UI.value_def("pf_shape"), 0, UI.value_def("pf_rnd1"), 0, 0, 0);
			break;
		case FX_IKAT:
			vl1 = vectorize_filter2(0,60,60,   0,0,null,   filter2_step/2, filter2_step, filter2_width, 100, 25, 0, filter2_rand_dist1);
			break;
		case FX_STRIPE:
			vl1 = vectorize_stripes(0,60,60,     0,0,null, 0, UI.valuef_def("stripe_width"), UI.value_def("stripe_variation"), 100, UI.value_def("stripe_rotation"), UI.value_def("stripe_rnd1"));
			break;
		case FX_GLACIER:
			vl1 = vectorize_glacier(0,60,60,     0,0,null, UI.valuef_def("glacier_width"), 100, 0, UI.value_def("glacier_rnd1"));
			break;
		case FX_CRIMP:
			vl1 = vectorize_crimp(0,60,60,       0,0,null, filter5_step, UI.valuef_def("crimp_size"), UI.valuef_def("crimp_wave"), 60, UI.value_def("crimp_rotation"), UI.value_def("crimp_rnd1"));
			break;
		case FX_THATCH:
			vl1 = vectorize_thatch(0,60,60,      0,0,null, filter6_step/2, filter6_step, UI.valuef_def("thatch_width"), UI.value_def("thatch_shape"), UI.value_def("thatch_spacing"), 80, 0, UI.value_def("thatch_rnd1"));
			break;
		case FX_CAIRO:
			vl1 = vectorize_cairo(0,60,60,       0,0,null, UI.valuef_def("cairo_size"), UI.valuef_def("cairo_angle"), UI.value_def("cairo_rnd1"), UI.valuef_def("cairo_rotation"));
			break;
		case FX_SCATTER:
			scatter_init_new();
			vl1 = vectorize_scatter(0,60,60,    0,0,null, 1, 80, 0, 20, 0 );
			break;
		case FX_ZAG:
			vl1 = vectorize_zag(0,60,60,    0,0,null, 1, 1.5, 1.5, UI.valuef_def("zag_variation"), 0, UI.value_def("zag_rand1"));
			break;
		case FX_SEQUENCE:
			vl1 = vectorize_sequence(0,60,60,   0,0,null, UI.valuef_def("sequence_width"), UI.valuef_def("sequence_height"), UI.value_def("sequence_variation"), UI.value_def("sequence_break"), UI.value_def("sequence_shuffle"), 0, 0);
			break;
		case FX_ICE:
			vl1 = vectorize_ice(0,60,60,   0,0,null, 2.5 /*UI.valuef_def("ice_scale")*/, UI.value_def("ice_shape"), UI.value_def("ice_spacing"), UI.value_def("ice_shuffle"), UI.value_def("ice_angle"), UI.value_def("pf_rnd1"), 0, 0, 0);
			break;
		case FX_CAPE:
			vl1 = vectorize_cape(0,60,60,   0,0,null, 10/*UI.valuef_def("cape_scale")*/, UI.value_def("cape_stripe"), UI.value_def("cape_shape"), UI.value_def("cape_rnd1"), 0, 0, 0);
			break;
	}

	paint_vectors(context_bitmap, vl1, THUMB_SIZE, 60, 60, 1, 2, -1, -1, 0, 4);

	layer1_img = new Image();
	layer1_img.src = canvas_bitmap.toDataURL("image/raw");
	if (typeof pf_nodejs === "undefined")
		layer1_img.onload = function func() { fxlist_generate_thumb_phase2(pos, api, callback); };
	else
		fxlist_generate_thumb_phase2(pos, api, callback);
}

function fxlist_generate_thumbs()
{
	THUMB_SIZE = 150;

	canvas_bitmap.width = THUMB_SIZE;
	canvas_bitmap.height = THUMB_SIZE;
	canvas_bitmap.style.width = THUMB_SIZE;
	canvas_bitmap.style.height = THUMB_SIZE;

	fxlist_generate_thumb_phase1(0, 0, null);
}

function fxlist_paint()
{
	var a;
	var y, w;

	rect(context[C_FX], 0, 0, canvas[C_FX].width, canvas[C_FX].height, FILL, col_UI_background, 1);
	context[C_FX].globalAlpha = 1;
	for (a = 0; a < FX_NUM; a++)
	{
		y = THUMBS_TOP + (a * THUMBS_SPAN) - fxlist.scroll_pos;
		w = measure_text(context[C_FX], fx_name[a], FXLIST_FONT);
		draw_text(context[C_FX], THUMBS_LEFT + (THUMB_SIZE - w) / 2, y + THUMB_SIZE + 20, fx_name[a], FXLIST_FONT, col_black, 1);
		rect(context[C_FX], THUMBS_LEFT - 1, y - 1, THUMB_SIZE+2, THUMB_SIZE+2, OUTLINE, a == fx_selected ? fxlist_col_sel : col_gray, 1);
		if (fx_thumbs_ready)
		{

			if (a == fx_selected)
				context[C_FX].globalAlpha = 1;
			else
				context[C_FX].globalAlpha = 0.33;

			context[C_FX].drawImage(fx_thumb_img[a], THUMBS_LEFT, y, THUMB_SIZE, THUMB_SIZE);
		}
	}
	fxlist_paint_scrollbar();
}

function fxlist_paint_scrollbar()
{
	if (!fxlist.scrollbar) return;

	rect(context[C_FX], fxlist.width - FX_BAR_WIDTH - FX_BAR_RIGHT, FX_BAR_VERT_GAP, FX_BAR_WIDTH, fxlist.scroll_height, FILL, col_UI_background, 1);
	rect_round(context[C_FX], fxlist.width - FX_BAR_WIDTH - FX_BAR_RIGHT, FX_BAR_VERT_GAP, FX_BAR_WIDTH, fxlist.scroll_height, 5, OUTLINE, col_gray_lite, 1);
	rect_round(context[C_FX], fxlist.width - FX_BAR_WIDTH - FX_BAR_RIGHT, FX_BAR_VERT_GAP + fxlist.scrollbar_pos, FX_BAR_WIDTH, FX_BAR_HEIGHT, 5, FILL, col_gray, 1);
}

function fxlist_update_scrollbar(mx, my, move)
{
	var sx = fxlist.width - FX_BAR_WIDTH - FX_BAR_RIGHT;
	var y, sy;
	if ((mx >= sx - 4 && mx < sx + FX_BAR_WIDTH + 4) || move)
	{
		var hh = (FX_BAR_HEIGHT >> 1);

		sy = my - FX_BAR_VERT_GAP;
		if (sy < hh) sy = hh;
		else
		if (sy >= fxlist.scroll_height - hh) sy = fxlist.scroll_height - hh;

		fxlist.scrollbar_pos = sy - hh;
		fxlist.scroll_pos = ((fxlist.height - (fxlist.disp_height + hh)) * sy) / (fxlist.scroll_height - FX_BAR_HEIGHT);
		fxlist_paint();
		fxlist.drag = 1;
	}
}

function fxlist_mouse_move(mx, my)
{
	if (!fxlist.scrollbar) return;
	if (!fxlist.drag) return;
	fxlist_update_scrollbar(mx, my, 1);
}

function fxlist_mouse_down(mx, my)
{
	var a, y;

	for (a = 0; a < FX_NUM; a++)
	{
		y = THUMBS_TOP + (a * THUMBS_SPAN) - fxlist.scroll_pos;
		if (fx_selected != a && mx >= THUMBS_LEFT && mx < THUMBS_LEFT + THUMB_SIZE && my >= y && my < y + THUMB_SIZE)
		{
			undo_add(UNDO_ACTION_FILTER, 0, fx_selected);
			fxlist_select(a);
			break;
		}
	}
	if (fxlist.scrollbar)
		fxlist_update_scrollbar(mx, my, 0);
}

function fxlist_mouse_up(mx, my)
{
	fxlist.drag = 0;
}

function fxlist_mouse_callback(event, mx, my, btn, wheel)
{
	
	pos = getPosition(canvas[C_FX]);
	mx -= pos.x;
	my -= pos.y;
	switch (event)
	{
		case MOUSE_DOWN:
			fxlist_mouse_down(mx, my);
			break;
		case MOUSE_UP:
			fxlist_mouse_up(mx, my);
			break;
		case MOUSE_MOVE:
			fxlist_mouse_move(mx, my);
			break;
//		case MOUSE_WHEEL:
//			fxlist_mouse_wheel(wheel);
			break;
	}

}

function is_fxlist_scrollbar(hei)
{
	return( hei > (fxlist.height - THUMBS_TOP) ? 0 : 1 );
}

function fxlist_resized()
{
	fxlist.width = canvas[C_FX].width;
	fxlist.disp_height = canvas[C_FX].height;
	fxlist.scroll_height = fxlist.disp_height - (FX_BAR_VERT_GAP * 2);
	fxlist.height = THUMBS_TOP*2 + (FX_NUM * THUMBS_SPAN);
	fxlist.scrollbar = fxlist.disp_height > (fxlist.height - THUMBS_TOP) ? 0 : 1;
	fxlist.scroll_pos = 0;
}

function fxlist_init()
{
	page_mouse_callback_register(fxlist_mouse_callback)

	fxlist_resized();
}

function fxlist_generate_preview(filter, thumb_size, callback)
{
	THUMB_SIZE = thumb_size;
	canvas_bitmap.width = THUMB_SIZE;
	canvas_bitmap.height = THUMB_SIZE;
	if (typeof pf_nodejs === "undefined")
	{
		canvas_bitmap.style.width = THUMB_SIZE;
		canvas_bitmap.style.height = THUMB_SIZE;
	}

	fxlist_generate_thumb_phase1(filter, 1, callback);
}